export var indexPrefix  = '@';
export var scalePrefix  = '%';
export var dataPrefix   = ':';



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-parser/src/parsers/expression/prefixes.js
// module id = 137
// module chunks = 0